import { StorageSerializers, useLocalStorage } from '@vueuse/core';
import { defineStore } from 'pinia';
import { computed } from 'vue';
import User from '@/domain/model/business/User.ts';

const USER_KEY = 'user';
const ADMIN_MODE_KEY = 'user.admin-store';

interface UserJson {
  id: number;
  email: string;
  first_name: string;
  last_name: string;
  admin?: boolean;
  robot?: boolean;
  auto_unsubscribed?: boolean;
  subscribed_to_status_emails?: boolean;
  created_at?: string;
  deleted_at?: string;
}

export const useUserStore = defineStore('user', () => {
  const userData = useLocalStorage<UserJson | null>(USER_KEY, null, {
    serializer: StorageSerializers.object,
  });
  const adminMode = useLocalStorage<boolean>(ADMIN_MODE_KEY, false);

  const user = computed<User | null>(() =>
    userData.value
      ? new User(
          userData.value.id,
          userData.value.email,
          userData.value.first_name,
          userData.value.last_name,
          userData.value.admin,
          userData.value.robot,
          userData.value.auto_unsubscribed,
          userData.value.subscribed_to_status_emails,
          userData.value.created_at,
          userData.value.deleted_at,
        )
      : null,
  );

  function set(newUser: UserJson): void {
    userData.value = newUser;
    adminMode.value = true;
  }

  function setAdminMode(value: boolean): void {
    adminMode.value = value;
  }

  function clear(): void {
    userData.value = null;
    adminMode.value = false;
  }

  return { user, adminMode, set, setAdminMode, clear };
});
